module.exports = __webpack_public_path__ + "media/images/faqs/ready-to-invest-d244928991aff864d576625b094ccbaa.png";